export const DocumentFormSettingsKey = [
  "document",
  "document-landing-page",
  "post-event-assets",
  "ppc",
  "case-study",
  "digital-maturity-assessment",
] as const;
export type DocumentFormSettingsKey = (typeof DocumentFormSettingsKey)[number];


export const VideoFormSettingsKey = [
  "video",
  "video-landing-page",
  "post-event-assets",
  "video-gated",
  "ppc-video",
] as const;
export type VideoFormSettingsKey = (typeof VideoFormSettingsKey)[number];

export const VideoGatedFormSettingsKey =[
  "video-gated",
  "ppc-video",
  "video-landing-page",
] as const;
export type VideoGatedFormSettingsKey = (typeof VideoGatedFormSettingsKey)[number];

export const CustomResourceFormSettingsKey = ["qx-demo-video"] as const;
export type CustomResourceFormSettingsKey = (typeof CustomResourceFormSettingsKey[number]);


export const ContactFormSettingsKey = [
  "contact",
  "qx-roi",
  "mx-roi",
  "spark",
  "pricing",
  "subscription",
  "partner",
  "demo-request",
  "tradeshow-giveaway",
  "event-registration",
  "subprocessor-update-notification",
  "ppc-contact",
] as const;
export type ContactFormSettingsKey = (typeof ContactFormSettingsKey)[number];

export const MaturityFormKey = ["digital-maturity-assessment"] as const;
export type MaturityFormKey = (typeof MaturityFormKey)[number];

export const AnyFormSettingsKey = [
  ...DocumentFormSettingsKey,
  ...VideoFormSettingsKey,
  ...ContactFormSettingsKey,
  ...MaturityFormKey,
  ...CustomResourceFormSettingsKey
] as const;
export type AnyFormSettingsKey = (typeof AnyFormSettingsKey)[number];

export type FormSettingsKeyToValueMapping<TMapping> = {
  readonly [key in AnyFormSettingsKey]: TMapping;
};

